module.exports = __webpack_public_path__ + "static/media/9.d894cf9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cats/9.jpg
// module id = 214
// module chunks = 0